import moment from "moment-timezone";

export interface IReportFilterOp {
    DataDa: string,
    DataA: string,
    IdSpeaker: {value: string, label: string} | any,
}

export function AdapterReportFilterEsito(filter: IReportFilterOp) {
    let filterMap: IReportFilterOp;
    return filterMap = {
        DataDa: filter?.DataDa ? moment.tz(filter?.DataDa, "DD-MM-YYYY HH:mm", "Europe/Rome").toISOString() : '',
        DataA: filter?.DataA ? moment.tz(filter?.DataA, "DD-MM-YYYY HH:mm", "Europe/Rome").toISOString() : '',
        IdSpeaker: filter?.IdSpeaker?.value ? Number(filter?.IdSpeaker?.value) : null,
    } 
} 

